import { constants, mediaQueryStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const { breakpoints } = constants;
const { md } = breakpoints.BreakpointNames;
const { mediaQuery: breakpoint } = mediaQueryStyles;

export const modalCss = {
  root: {
    zIndex: 4,
    // Because the ElaSkillsActivityPanel which houses Article Topics has a higher z-index on smaller screens, the modal needs a higher z-index on smaller screens
    [breakpoint.upTo(md)]: {
      zIndex: 12,
    },
  },
};

export const reportContentFormCss = {
  backgroundColor: ui.white[500],
  padding: "20px",
  borderRadius: "4px",
  minWidth: "371px",
  minHeight: "241px",
};

export const reportContentFormHeadingCss = {
  marginTop: 0,
};
